export default {
  BusinessPurchaseComponentsExcel: {
    title: '导入',
    rules: 'Excel导入供应商规则说明',
    p1: '如果系统已存在供应商编码资料，根据供应商编码更新数据，否则新建供应商信息',
    p2: '导入供应商信息模板，点击下载',
    information: '供应商信息模板',
    p3: '导入Excel格式必须带标题，红色标题为必填；Excel的列请设置为文本格式，不然可能会出现类型转换错误的问题',
    p4: '支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过6万行，如果超过，请分成多次导入。',
    uploadSize: '上传大小不能超过128MB',
    import: '确认导入',
    name: '供应商信息模板.xlsx'
  }
};
